import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  appStatus: true,
  shopInfo: {
    shopOwner: "",
    email: "",
    shopName: "",
    myshopifyDomain: "",
  },
  listNotification: [],
  notificationsDetail: null,
  handleStatusResult: 0, // 0 trạng thái ban đầu, 1 thay đổi thành công, 2 thay đổi thất bại
  handleStatusLoading: false,
  statusMenu: false,
  randomProductResult: "",
});

let data;

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_RESULT_FIELD:
      data = action.payload;
      return state.set(data.field, data.value);
    case types.CHANGE_APP_STATUS:
      return state
        .set("appStatus", !state.get("appStatus"))
        .set("handleStatusLoading", true)
        .set("handleStatusResult", 0);
    case types.CHANGE_APP_STATUS_RESULT:
      data = action.payload;
      return state
        .set("appStatus", data.res === 1 ? data.status : !data.status)
        .set("handleStatusLoading", false)
        .set("handleStatusResult", data.res);
    case types.GET_LIST_NOTIFICATION_RESULT:
      return state.set("listNotification", fromJS(action.payload));
    case types.GET_NOTIFICATION_DETAIL_RESULT:
      return state.set("notificationsDetail", fromJS(action.payload[0]));
    case types.GET_SHOP_INFO_RESULT:
      data = action.payload;
      if (
        data &&
        data.myshopify_domain &&
        data.myshopify_domain.includes(".myshopify.com")
      ) {
        window.fcWidget.user.setProperties({
          firstName: data.name,
          shopOwner: data.shop_owner,
          email: data.email,
          phone: data.phone,
          timezone: data.timezone,
          shop: data.myshopify_domain,
        });
        const style = document.createElement("style");
        style.innerHTML = "#fc_frame{display: unset!important;}";
        document.body.appendChild(style);
      }
      return state
        .setIn(["shopInfo", "shopOwner"], data.shop_owner)
        .setIn(["shopInfo", "email"], data.email)
        .setIn(["shopInfo", "shopName"], data.name)
        .setIn(["shopInfo", "myshopifyDomain"], data.myshopify_domain);

    case types.CHANGE_STATUS_MENU:
      return state.set("statusMenu", !state.get("statusMenu"));

    case types.GET_RANDOM_PRODUCT_RESULT:
      return state.set("randomProductResult", action.payload.handle);

    default:
      return state;
  }
};

export default appReducer;
